


























































































import { Scrollbar, Tabs } from '@/app/components';
import { useAxios } from '@/app/composable';
import { UserRoles } from '@/app/constants';
import store from '@/app/store';
import { maxLengthValidator, minLengthValidator } from '@/app/validators';
import { computed, defineComponent, ref } from '@vue/composition-api';
import { TrinityRingsSpinner } from 'epic-spinners';
import * as R from 'ramda';
import { extend } from 'vee-validate';
import { alpha_num, email, regex, required } from 'vee-validate/dist/rules';
import { OrganizationsAPI } from '../api';
import { OrganisationMembers, OrganisationOverview, SharingOptions } from '../components';
import { useOrganisation } from '../composable';

extend('required', {
    ...required,
    message: '{_field_} is required',
});
extend('email', email);
extend('regex', {
    ...regex,
    message: 'No special characters allowed',
});
extend('alpha_num', {
    ...alpha_num,
    message: 'Use only aplhanumeric characters',
});
extend('min', minLengthValidator);
extend('max', maxLengthValidator);

export default defineComponent({
    name: 'EditOrganization',
    metaInfo: {
        title: 'Organisation Details',
    },
    components: {
        TrinityRingsSpinner,
        Tabs,
        Scrollbar,
        OrganisationMembers,
        OrganisationOverview,
        SharingOptions,
    },
    setup(props, { root }) {
        const { exec, loading, error } = useAxios(true);
        const organizationDetailsRef = ref<any>();
        const user = ref(store.state.auth.user);
        const organizationRoles = ref([]);
        const activeTab = ref(0);
        const tabs = ref([
            { id: 0, title: 'Overview' },
            { id: 1, title: 'Members' },
        ]);

        const completeOrganization = computed(() => store.getters.organisation.details);
        const organizationUsers = computed(() => store.getters.organisation.users);
        const countries = computed(() => store.getters.locations.countries);
        const isManager = computed(() => store.getters.auth.hasRole(UserRoles.Manager));
        const isLegalRepresentative = computed(() => store.getters.auth.hasRole(UserRoles.LegalRepresentative));

        if (isLegalRepresentative.value) tabs.value.push({ id: 2, title: 'Contracts and Sharing Options' });

        const refetch = () => {
            useOrganisation(user.value.organisationId).initialize();
        };

        const refetchRoles = () => {
            exec(OrganizationsAPI.retrieveRoles(user.value.organisationId))
                .then((res: any) => {
                    organizationRoles.value = res.data;
                })
                .catch(() => {
                    (root as any).$toastr.e('An error has occurred', 'Error');
                });
        };

        refetchRoles();

        const tabClicked = (idx: number) => {
            activeTab.value = idx;
        };

        const scrollToTop = () => {
            if (organizationDetailsRef.value) organizationDetailsRef.value.scrollToTop();
        };

        return {
            tabs,
            activeTab,
            loading,
            error,
            countries,
            completeOrganization,
            organizationRoles,
            tabClicked,
            user,
            isManager,
            refetch,
            organizationUsers,
            refetchRoles,
            R,
            organizationDetailsRef,
            scrollToTop,
        };
    },
});
